import React = require('react');
import { style } from 'typestyle';
import { CommonStyles } from '~src/common/react/CommonStyles';

export const sectionHeader = style({
  fontSize: CommonStyles.Sizes.HeaderFontSize,
  fontWeight: 'bold',
  marginTop: CommonStyles.Sizes.LineHeight,
  borderBottom: `1px solid ${CommonStyles.Colors.Grey245}`,
  paddingBottom: 10,
});

export const buttonStyle = style({
  cursor: 'pointer',
});

export const addButtonStyle = style({
  marginLeft: 15,
});

export const addButtonInfoStyle = style({
  $nest: {
    'img': {
      verticalAlign: 'middle',
    },
  },
});

export const textFieldStyle = style({
  $nest: {
    'input': {
      background: 'white',
    },
  },
});

export const dropDownStyle = style({
  paddingTop: 4,
  paddingRight: 8,
  $nest: {
    'button': {
      background: 'white',
    },
  },
});

// tsignore here is because !important is not a valid value for 
//  position key, but it propagates properly to css.
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
export const dataGridContainerStyle = style({
  // We are using !important here below because the datagrid
  //  does not support dynamic sizing.
  $nest: {
    '.tb-react-dg-hrow': {
      position: 'inherit !important',
    },
    '.tb-react-dg-body': {
      position: 'inherit !important',
    },
    '.tb-react-data-grid': {
      position: 'inherit !important',
    },
  },
});

export const dataGridBlockContainerStyle = style({
  width: 400,
});

export const dataGridSafeContainerStyle = style({
  width: 625,
});

export const tooltipStyle = style({
  marginLeft: 3,
  verticalAlign: 'text-top',
});

export const dataGridRowHeight = 32;
